import { Track } from '@fiverr-private/carousel';

export default Track;
